<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title class="mb-4">
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-image-frame
                </v-icon>
              </v-col>
              <v-col cols="12">
                <div
                  v-if="!newSuccessMessage"
                >
                  <p class="headline font-weight-black">
                    Hier kannst Du das Team-Logo ändern!
                  </p>
                  <p class="caption">
                    Dieses Logo wird ggf. nach außen Sichtbar sein und für das Chat- / Nachrichtensystem verwendet. <br>Achte auf die Urheberrechte!<br><small>(Das Speichern könnte etwas länger dauern.)</small>
                  </p>
                  <v-row
                    v-show="currentLogo != ''"
                  >
                    <v-col>
                      <h3 class="title">
                        Dein aktuelles Team-Logo:
                      </h3>
                      <v-avatar
                        size="62"
                        class="grey lighten-4"
                      >
                        <v-img :src="currentLogo" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <v-dialog
                        v-model="dialog"
                        max-width="480"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="red darken-1"
                            dark
                          >
                            Aktuelles Team-Logo löschen
                            <v-icon right dark>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                          >
                            Team-Logo wirklich löschen?
                          </v-card-title>

                          <v-card-text class="py-2">
                            <p class="body-1">
                              Wenn Du das Team-Logo wirklich löschen willst, dann klicke auf "Wirklich Löschen!"<br>
                              Ansonsten klicke auf Abbrechen!
                            </p>
                          </v-card-text>

                          <v-divider />

                          <v-card-actions>
                            <div class="flex-grow-1" />
                            <v-btn
                              color="primary"
                              @click="dialog = false"
                            >
                              Abbrechen
                            </v-btn>
                            <div class="flex-grow-1" />

                            <v-btn
                              color="red darken-1"
                              dark
                              @click="deleteCurrentTeamLogo()"
                            >
                              Wirklich Löschen!
                              <v-icon right dark>
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <p class="title green--text">
                    Teamlogo erfolgreich geändert!
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row v-if="!newSuccessMessage">
              <v-col
                cols="12"
                sm="6"
              >
                <v-file-input
                  :rules="imageRules"
                  id="teamimagefile"
                  accept="image/png, image/jpeg"
                  show-size
                  label="Team-Logo"
                  placeholder="Neues Logo suchen..."
                  prepend-icon="mdi-camera"
                  @change="onFileChange"
                  v-model="teamLogoFile"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="text-center"
              >
                <p class="title">
                  Logo-Vorschau:
                </p>
                <v-avatar
                  v-show="showTeamImage"
                  size="62"
                  class="grey lighten-4"
                >
                  <v-img :src="teamimage" />
                </v-avatar>
                <br>
              </v-col>
              <my-alert
                v-if="this.$store.state.error"
                type="error"
                :error="this.$store.state.error"
                :title="this.$store.state.errorTitle"
              />
            </v-row>
            <v-row v-else>
              <v-col>
                <p class="title green--text text-center">
                  Glückwunsch! Der Server hat Dein neues Teamlogo erfolgreich gespeichert.
                </p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions
            v-show="!newSuccessMessage"
            class="text-center mb-6 pb-6"
          >
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelLogo()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              v-show="showSaveButton"
              outlined
              large
              class="primary--text mx-auto"
              @click="saveTeamLogo()"
              :loading="this.$store.state.loading"
            >
              speichern <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_SET_SNACKBAR } from '../../store/mutation-types'
export default {
  name: 'Teamlogo',
  metaInfo: {
    title: 'Teamlogo ändern'
  },
  data () {
    return {
      imageRules: [
        value => !value || value.size < 2097152 || 'Das Logo darf nicht größer als 2 MB sein!'
      ],
      newSuccessMessage: false,
      teamimage: '',
      showTeamImage: false,
      currentLogo: '',
      dialog: false,
      teamLogoFile: null,
      showSaveButton: false,
      fileType: '.jpg'
    }
  },
  methods: {
    cancelLogo: function () {
      this.$router.replace({ path: '/settings' })
    },
    saveTeamLogo: async function () {
      // save send with axios
      if (await this.$store.dispatch('teamStore/saveTeamLogo', {
        image: this.teamimage,
        type: this.fileType
      })) {
        // switch to success
        this.newSuccessMessage = true
      }
    },
    onFileChange: function (File) {
      if (!File) {
        document.getElementById('teamimagefile').value = ''
        this.showSaveButton = false
        this.teamLogoFile = null
        this.teamimage = ''
        this.showTeamImage = false
        return false
      }
      const filesize = ((this.teamLogoFile.size / 1024) / 1024).toFixed(2) // MB
      if (filesize > 2) {
        // show error
        this.$store.commit(ROOT_SET_SNACKBAR, 'Datei darf nicht größer als 2 MB sein')
        document.getElementById('teamimagefile').value = ''
        this.showSaveButton = false
        return false
      }

      const type = this.teamLogoFile.type
      if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png') {
        this.$store.commit(ROOT_SET_SNACKBAR, 'Nur JPEG oder PNG Bilder sind erlaubt.')
        return false
      }
      this.fileType = type
      this.createImage(this.teamLogoFile)
    },
    setImage: function (src) {
      this.teamimage = src
      this.showSaveButton = true
      this.showTeamImage = true
    },
    createImage: function (file) {
      const reader = new FileReader()
      const vm = this
      reader.onload = function (e) {
        vm.setImage(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    deleteCurrentTeamLogo: async function () {
      // commit to server that logo is deleted
      if (await this.$store.dispatch('teamStore/deleteTeamLogo')
      ) {
        // hinweis geben das das bild gelöscht wurde und aktuelles bild ausblenden
        this.currentLogo = ''
      }
      this.dialog = false
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
    // load current logo
    this.currentLogo = this.$store.state.teamStore.team.logo
  }
}
</script>
